(function ($) {
    $('.testimonail-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      prevArrow:'<button class="arrow-slick1 prev-slick1"><i class="fa  fa-angle-left" aria-hidden="true"></i></button>',
      nextArrow:'<button class="arrow-slick1 next-slick1"><i class="fa  fa-angle-right" aria-hidden="true"></i></button>', 
      responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
    });
  
  // var intervalOpen = setInterval(subscribeOpen, 5000); 
  // var intervalHide = setInterval(doStuff, 7000); 
  function subscribeOpen() {
    jQuery(".subscribe-info").css("display", "block");
    clearInterval(intervalOpen);
    setInterval(doStuff, 7000);
  }
  function doStuff() {
    jQuery(".subscribe-info").css("display", "none");
    clearInterval(intervalHide);
    setInterval(subscribeOpen, 5000);
  }
  jQuery(".close-icon").on("click", function() {
    jQuery(".subscribe-info").css("display", "none");
  });

  $(document).ready(function(){
    jQuery("body.gift-box-builder #shopify-section-footer").appendTo("body");
    jQuery('#appView').contents().find('.blog.js-powrMark').hide();
    setTimeout(function() {
      jQuery('#appView').contents().find('.blog.js-powrMark').hide();
    }, 6000)


  });


  
})(jQuery);